import { useQuery } from '@tanstack/react-query';

import { productApi } from '../../../api/product';

export const isFeatureOnQueryKey = {
    all: ['isFeatureOn'],
    byFeature: (feature) => ['isFeatureOn', feature],
};

/**
 * Hook to check if a feature is on
 *
 * @param {string} feature - The feature to check if it is on
 * @param {number} gcTime - The time to keep the data in cache in milliseconds
 * @returns {import('@tanstack/react-query').UseQueryResult<boolean, Error>}
 */
export const useIsFeatureOn = (feature, gcTime = 15 * 60_000) =>
    useQuery({
        queryKey: isFeatureOnQueryKey.byFeature(feature),
        queryFn: async ({ signal }) => {
            const response = await productApi.getIsFeatureOn(feature, { signal });
            if (!response.status) {
                throw new Error(response.msg);
            }
            return response.data.isFeatureOn;
        },
        enabled: !!feature,
        staleTime: Infinity,
        gcTime,
    });
